import React from 'react';
import notify from 'devextreme/ui/notify';
import { chartServices } from '../../services/chart.service';
import { childrenServices } from '../../services/children.service';
import { userServices } from '../../services/user.service';
import moment from "moment";
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import Form from 'react-bootstrap/Form';

export class ChartSMS extends React.Component {
    constructor(props) {
        super(props);
        let now = new Date();
        let start = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
        let end = moment(start).add(1, "days").subtract(1, "seconds");
        require('highcharts/indicators/indicators')(Highcharts);
        require('highcharts/indicators/pivot-points')(Highcharts);
        require('highcharts/indicators/macd')(Highcharts);
        require('highcharts/modules/exporting')(Highcharts);
        require('highcharts/modules/map')(Highcharts);
        require('highcharts/modules/export-data')(Highcharts);
        this.state = {
            sms: [],
            hashtags: [],
            userChildren: [],
            selectedChild: '',
            selectedHashtag: '',
            message: '',
            phoneNumber: localStorage.getItem('phoneNumber'),
            userId: localStorage.getItem('userId'),
            start: start,
            end: end,
            countSmsPerDay: [],
            countHashtagPerDay: [],

            smsPerDayChartOptions: {
                chart: {
                    type: 'spline'
                },
                title: {
                    text: 'Message Count per Day'
                },
                subtitle: {
                    text: ''
                },
                xAxis: {
                    type: 'datetime',
                    title: {
                        text: 'Date'
                    },
                    dateTimeLabelFormats: {
                        month: '%e. %b, %Y',
                        year: '%Y'
                    }
                },
                yAxis: {
                    title: {
                        text: 'Number of SMS'
                    },
                    min: 0
                },
                tooltip: {
                    headerFormat: '<b>{series.name}</b><br>',
                    pointFormat: '{point.x:%e/%b}:  {point.y} SMS'
                },

                plotOptions: {
                    series: {
                        marker: {
                            enabled: true
                        }
                    }
                },

                colors: ['#6CF', '#39F', '#06C', '#036', '#000'],

                series: [{
                    name: "SMS",
                    data: []
                }],

                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            plotOptions: {
                                series: {
                                    marker: {
                                        radius: 2.5
                                    }
                                }
                            }
                        }
                    }]
                }
            },

            hashtagPerDayChartOptions: {
                chart: {
                    type: 'spline'
                },
                title: {
                    text: 'Hashtag Count per Day'
                },
                subtitle: {
                    text: ''
                },
                xAxis: {
                    type: 'datetime',
                    title: {
                        text: 'Date'
                    },
                    dateTimeLabelFormats: {
                        month: '%e. %b, %Y',
                        year: '%Y'
                    }
                },
                yAxis: {
                    title: {
                        text: 'Total Instances'
                    },
                    min: 0
                },
                tooltip: {
                    headerFormat: '<b>{series.name}</b><br>',
                    pointFormat: '{point.x:%e/%b}:  {point.y} SMS'
                },

                plotOptions: {
                    series: {
                        marker: {
                            enabled: true
                        }
                    }
                },

                colors: ['#6CF', '#39F', '#06C', '#036', '#000'],

                series: [{
                    name: "Hashtag",
                    data: []
                }],

                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            plotOptions: {
                                series: {
                                    marker: {
                                        radius: 2.5
                                    }
                                }
                            }
                        }
                    }]
                }
            }
        };

        var search = new URLSearchParams(this.props.location.search);
        var selectedUserId = search.get("id");
        var roleType = localStorage.getItem('roleType');
        if (selectedUserId != null) {
            this.setState({ userId: selectedUserId });
            userServices.getById(selectedUserId).then(
                user => {
                    userServices.getRoleByName(user.roles[0]).then(
                        role => {
                            roleType = role.roleType;
                            if (roleType === 2 || roleType === 3 || roleType === 4) {//parent, therapist, caregiver
                                childrenServices.getByUserId(selectedUserId).then(
                                    data => {
                                        if (data.length > 0) {
                                            this.setState({ userChildren: data });
                                        }
                                    },
                                    error => {
                                        notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
                                    }
                                );
                            }
                            else if (roleType === 1) {//admin
                                childrenServices.getAll().then(
                                    data => {
                                        if (data.length > 0) {
                                            this.setState({ userChildren: data });
                                        }
                                    },
                                    error => {
                                        notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
                                    }
                                );
                            }
                        },
                        error => {
                            notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
                        }
                    );
                },
                error => {
                    notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
                }
            );
        }
        else {
            if (roleType === '2' || roleType === '3' || roleType === '4') {//parent, therapis, caregiver
                childrenServices.getByUserId(this.state.userId).then(
                    data => {
                        if (data.length > 0) {
                            data.push({ 'firstName': 'All My Messages', 'lastName': '', 'childrenId': 'All' });
                            this.setState({ userChildren: data });
                        }
                    },
                    error => {
                        notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
                    }
                );
            }
            else if (roleType === '1') {//admin
                childrenServices.getAll().then(
                    data => {
                        if (data.length > 0) {
                            this.setState({ userChildren: data });
                        }
                    },
                    error => {
                        notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
                    }
                );
            }
        }

        function processData(data, xField, yField) {
            return data.map(function (obj) {
                return [Date.parse(obj[xField]), parseInt(obj[yField], 10)];
            });
        }

        chartServices.getCountSmsPerDay(localStorage.getItem('userId')).then(
            data => {
                if (data.length > 0) {
                    this.countSmsPerDay = processData(data, 'key', 'value');

                    this.setState({
                        smsPerDayChartOptions: {
                            series: [
                                { data: this.countSmsPerDay }
                            ]
                        }
                    });
                }
            },
            error => {
                notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
            }
        );

        chartServices.getAllHashtags(localStorage.getItem('userId')).then(
            data => {
                if (data.length > 0) {
                    this.setState({ hashtags: data });
                }
            },
            error => {
                notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
            }
        );

        this.applyCallback = this.applyCallback.bind(this);
        this.onChildChanged = this.onChildChanged.bind(this);
        this.onHashtagChanged = this.onHashtagChanged.bind(this);
    }

    componentDidMount() {
        this.smsPerDayChartRef = React.createRef();
    }

    onChildChanged(e) {
        this.setState({ selectedChild: e.target.value });
        this.updateHashtagData(e.target.value, this.state.selectedHashtag);
    }

    onHashtagChanged(e) {
        this.setState({ selectedHashtag: e.target.value });
        this.updateHashtagData(this.state.selectedChild, e.target.value);
    }

    processHashtagData(data, xField, yField) {
            return data.map(function (obj) {
            return [Date.parse(obj[xField]), parseInt(obj[yField], 10)];
        });
    }

    updateHashtagData(selectedChild, selectedHashtag) {
        if (selectedChild != '' && selectedHashtag != '') {
            var convertedHashtag = selectedHashtag.substr(1);
            chartServices.getCountHashtagPerDay(selectedChild, convertedHashtag).then(
                data => {
                    if (data.length > 0) {
                        this.countHashtagPerDay = this.processHashtagData(data, 'key', 'value');

                        this.setState({
                            hashtagPerDayChartOptions: {
                                series: [
                                    { data: this.countHashtagPerDay }
                                ]
                            }
                        });
                    }
                },
                error => {
                    notify({ position: 'top right', message: "Failed: " + error, type: 'error', maxWidth: 200, closeOnOutsideClick: false, closeOnClick: true, displayTime: 6000 });
                }
            );
        }
    }

    applyCallback(startDate, endDate) {
        this.setState({
            start: startDate,
            end: endDate
        });
    }

    render() {
        const { userChildren, hashtags, message } = this.state;

        return (
            <div>
                <br />
                <span style={{ color: "red" }}>{message}</span>
                <br />
                <Form>
                    <Form.Group controlId="chartForm.SelectChild">
                        <Form.Label>Select Child</Form.Label>
                        <Form.Control as="select" onChange={this.onChildChanged} custom>
                            <option value="">Select Child</option>
                            {
                                userChildren.map((item, i) => (
                                    <option key={i} value={item.childrenId}>{item.firstName} {item.lastName}</option>
                                ))
                            }
                        </Form.Control>
                    </Form.Group>
                </Form>
                <br />
                <Form>
                    <Form.Group controlId="chartForm.SelectHashtag">
                        <Form.Label>Select Hashtag</Form.Label>
                        <Form.Control as="select" onChange={this.onHashtagChanged} custom>
                            <option value="">Select Hashtag</option>
                            {hashtags.map(hashtags => (
                                <option>{hashtags}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Form>
                <br />
                <HighchartsReact highcharts={Highcharts} constructorType={'chart'} options={this.state.hashtagPerDayChartOptions} ref={this.hashtagPerDayChartRef} />
                <br />
                <HighchartsReact highcharts={Highcharts} constructorType={'chart'} options={this.state.smsPerDayChartOptions} ref={this.smsPerDayChartRef} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/ChartSMS.js